import { Stack, Text, Box } from '@ltvco/refresh-lib/theme';
import { commaFormat, commaFormatCurrency } from '@ltvco/refresh-lib/utils';

import { PropertySummaryData } from '../DataTypes/SummaryTypes';

interface PropertyReportRendererProps {
  data: PropertySummaryData;
}

export const PropertyReportRenderer = ({
  data,
}: PropertyReportRendererProps) => {
  return (
    <Stack spacing={2}>
      {data.address && (
        <Text variant="body1">
          Here are the details for the property located at:{' '}
          <span style={{ fontWeight: 700 }}>{data.address}</span>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
            Property Overview:
          </Text>
          <Text variant="body1">
            <span style={{ fontWeight: 700 }}>🏠 Property:</span>{' '}
            {data.property_type || 'N/A'} | Built {data.year_built || 'N/A'} |{' '}
            {data.bedrooms || 'N/A'} beds | {data.bathrooms || 'N/A'} baths |{' '}
            {data.square_footage
              ? commaFormat(Number(data.square_footage))
              : 'N/A'}{' '}
            sq ft
            {data.lot_size &&
              ` | Lot: ${commaFormat(Number(data.lot_size))} Sq Ft`}
          </Text>
        </Box>

        {(data.estimated_value || data.taxes) && (
          <Box>
            <Text variant="body1" sx={{ fontWeight: 700, mb: 1 }}>
              💰 Financials:
            </Text>
            <Text variant="body1">
              {data.estimated_value &&
                `Estimated Value ${commaFormatCurrency(
                  Number(data.estimated_value)
                )}`}
              {data.estimated_value && data.taxes && ' | '}
              {data.taxes &&
                `${data.tax_year} Taxes ${commaFormatCurrency(
                  Number(data.taxes)
                )}`}
            </Text>
          </Box>
        )}

        {data.owners?.map((owner, index) => (
          <Box key={owner.names?.[0]?.full ?? index}>
            <Text variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
              Owner:
            </Text>
            <Text variant="body1">
              <strong>Name:</strong> {owner.names?.[0]?.full}
            </Text>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};
